<template>
  <d2-container>
    <template slot="header">
      <el-select v-model="query.targetType" clearable size="small" placeholder="收费目标" style="width: 140px; margin-right: 8px">
        <el-option label="个人" value="PERSONAL"></el-option>
        <el-option label="组织" value="ORGANIZATION"></el-option>
      </el-select>
      <el-select v-model="query.billingMode" clearable size="small" placeholder="收费模式" style="width: 180px; margin-right: 8px">
        <el-option v-for="item in billingModes" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="query.status" clearable size="small" placeholder="状态" style="width: 120px; margin-right: 8px">
        <el-option label="启用" :value="1"></el-option>
        <el-option label="停用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="openPlan()">新增套餐</el-button>
    </template>

    <el-table size="small" stripe border :data="records" v-loading="loading">
      <el-table-column prop="id" label="ID" width="120"></el-table-column>
      <el-table-column prop="planCode" label="编码" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="名称" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="目标" width="90">
        <template slot-scope="scope">{{ targetTypeLabel(scope.row.targetType) }}</template>
      </el-table-column>
      <el-table-column label="收费模式" width="160">
        <template slot-scope="scope">{{ billingModeLabel(scope.row.billingMode) }}</template>
      </el-table-column>
      <el-table-column label="周期" width="90">
        <template slot-scope="scope">{{ scope.row.periodCount }}{{ periodTypeLabel(scope.row.periodType) }}</template>
      </el-table-column>
      <el-table-column prop="basePrice" label="基础价" width="100" align="right"></el-table-column>
      <el-table-column label="席位配置" width="150" align="center">
        <template slot-scope="scope">{{ seatConfigText(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="Agent Plus" width="105" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.agentPlusEnabled ? 'success' : 'info'">
            {{ scope.row.agentPlusEnabled ? '已开' : '未开' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="LLM额度" width="130" align="right">
        <template slot-scope="scope">{{ scope.row.agentPlusEnabled ? quotaText(scope.row.llmQuotaAmount) : '-' }}</template>
      </el-table-column>
      <el-table-column label="额度用尽" width="150">
        <template slot-scope="scope">{{ scope.row.agentPlusEnabled ? llmQuotaPolicyLabel(scope.row.llmQuotaExhaustedPolicy) : '-' }}</template>
      </el-table-column>
      <el-table-column label="无限画布" width="90" align="center">
        <template slot-scope="scope">{{ scope.row.canvasInfinite ? '是' : '否' }}</template>
      </el-table-column>
      <el-table-column label="无限积分" width="150" align="right">
        <template slot-scope="scope">{{ pointPackageText(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openPlan(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>

    <el-dialog :title="form.id ? '编辑套餐' : '新增套餐'" :visible.sync="dialog" width="960px" class="plan-dialog">
      <el-alert
        class="dialog-alert"
        title="套餐只配置订阅基础价、组织席位、Agent Plus 和额度池；具体模型消耗仍走 LLM 价格表，后台不用在套餐里维护模型单价。"
        type="info"
        :closable="false"
        show-icon
      ></el-alert>

      <el-form :model="form" label-width="132px" class="plan-form">
        <div class="form-section-title">基础信息</div>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="套餐编码" required>
              <el-input v-model="form.planCode" placeholder="例如 personal_plus_month"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="套餐名称" required>
              <el-input v-model="form.name" placeholder="后台和用户端展示名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="收费目标" required>
              <el-select v-model="form.targetType" style="width: 100%" @change="handleTargetTypeChange">
                <el-option label="个人" value="PERSONAL"></el-option>
                <el-option label="组织" value="ORGANIZATION"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收费模式" required>
              <el-select v-model="form.billingMode" style="width: 100%" @change="handleBillingModeChange">
                <el-option v-for="item in planBillingModes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">收费周期</div>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="周期类型">
              <el-select v-model="form.periodType" style="width: 100%">
                <el-option label="月" value="MONTH"></el-option>
                <el-option label="年" value="YEAR"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="周期数量">
              <el-input-number v-model="form.periodCount" :min="1" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="基础价">
              <el-input-number v-model="form.basePrice" :min="0" :precision="2" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">组织席位</div>
        <div class="section-tip">只有“组织席位订阅”需要配置席位价和席位数量。统一席位就是 Plus 权益，组织购买几个席位就能分配几个 Plus 用户。</div>
        <el-row v-if="isOrgSeat" :gutter="12">
          <el-col :span="8">
            <el-form-item label="席位价">
              <el-input-number v-model="form.seatPrice" :min="0" :precision="2" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最小席位">
              <el-input-number v-model="form.minSeatCount" :min="1" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最大席位">
              <el-input v-model="form.maxSeatCount" placeholder="留空表示不限制"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">Agent Plus 与 LLM</div>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="Agent Plus">
              <el-switch v-model="form.agentPlusEnabled" active-text="开通"></el-switch>
              <div class="field-tip">开启后订阅期内可使用 Agent/LLM；组织套餐仍按席位分配。</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="LLM套餐额度">
              <el-input v-model="form.llmQuotaAmount" :disabled="!form.agentPlusEnabled" placeholder="留空表示不限额">
                <template slot="append">无限积分</template>
              </el-input>
              <div class="field-tip">留空=不限额；填 0=没有免费额度；填具体数值=订阅期总额度池。</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="额度用尽后">
              <el-select v-model="form.llmQuotaExhaustedPolicy" :disabled="!form.agentPlusEnabled" style="width: 100%">
                <el-option v-for="item in quotaPolicies" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <div class="field-tip">不限额时不会触发；有限额度不足时按这里处理。</div>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">其他权益</div>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="无限画布">
              <el-switch v-model="form.canvasInfinite"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开通赠送积分">
              <el-input-number v-model="form.grantPointAmount" :min="0" :precision="4" :step="10" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赠送有效天数">
              <el-input-number v-model="form.grantPointValidityDays" :min="0" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="每日发放积分">
              <el-input-number v-model="form.dailyPointAmount" :min="0" :precision="4" :step="10" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每日发放模式">
              <el-select v-model="form.dailyPointGrantMode" style="width: 100%">
                <el-option label="空间池" value="SPACE_POOL"></el-option>
                <el-option label="按席位放大" value="PER_SEAT" :disabled="!isOrgSeat"></el-option>
              </el-select>
              <div class="field-tip">按席位放大只适合组织席位订阅。</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每日有效天数">
              <el-input-number v-model="form.dailyPointValidityDays" :min="0" :step="1" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getSubscriptionPlans, saveSubscriptionPlan, updateSubscriptionPlan } from '@/api/ai/rights'
import { BILLING_MODE_OPTIONS, LLM_QUOTA_POLICY_OPTIONS, billingModeLabel, llmQuotaPolicyLabel, targetTypeLabel } from './labels'

export default {
  name: 'aiSubscriptionPlanManager',
  data () {
    return {
      billingModes: BILLING_MODE_OPTIONS,
      quotaPolicies: LLM_QUOTA_POLICY_OPTIONS,
      query: { currentPage: 1, pageSize: 20, targetType: '', billingMode: '', status: '' },
      records: [],
      total: 0,
      loading: false,
      dialog: false,
      form: this.defaultForm()
    }
  },
  computed: {
    planBillingModes () {
      if (this.form.targetType === 'PERSONAL') {
        return BILLING_MODE_OPTIONS.filter(item => item.value === 'PERSONAL_FIXED')
      }
      return BILLING_MODE_OPTIONS.filter(item => item.value !== 'PERSONAL_FIXED')
    },
    isOrgSeat () {
      return this.form.targetType === 'ORGANIZATION' && this.form.billingMode === 'ORG_SEAT'
    }
  },
  created () {
    this.load()
  },
  methods: {
    defaultForm () {
      return {
        planCode: '',
        name: '',
        targetType: 'PERSONAL',
        billingMode: 'PERSONAL_FIXED',
        periodType: 'MONTH',
        periodCount: 1,
        basePrice: 0,
        seatPrice: 0,
        minSeatCount: 1,
        maxSeatCount: '',
        canvasInfinite: false,
        agentPlusEnabled: false,
        llmQuotaAmount: '',
        llmQuotaExhaustedPolicy: 'PAY_AS_YOU_GO',
        grantPointAmount: 0,
        grantPointValidityDays: 30,
        dailyPointAmount: 0,
        dailyPointGrantMode: 'SPACE_POOL',
        dailyPointValidityDays: 1,
        status: 1
      }
    },
    load () {
      this.loading = true
      getSubscriptionPlans(this.query).then(res => {
        this.records = (res && res.records) || []
        this.total = Number((res && res.total) || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    billingModeLabel,
    llmQuotaPolicyLabel,
    targetTypeLabel,
    periodTypeLabel (type) {
      return type === 'YEAR' ? '年' : '月'
    },
    openPlan (row) {
      this.form = row ? Object.assign(this.defaultForm(), row) : this.defaultForm()
      if (this.form.billingMode === 'ORG_SEAT' && Number(this.form.maxSeatCount) === 0) {
        this.form.maxSeatCount = ''
      }
      if (this.form.llmQuotaAmount === null || this.form.llmQuotaAmount === undefined) {
        this.form.llmQuotaAmount = ''
      }
      this.ensureSeatDefaults()
      this.dialog = true
    },
    handleTargetTypeChange () {
      if (this.form.targetType === 'PERSONAL') {
        this.form.billingMode = 'PERSONAL_FIXED'
        this.form.dailyPointGrantMode = 'SPACE_POOL'
      } else if (this.form.billingMode === 'PERSONAL_FIXED') {
        this.form.billingMode = 'ORG_SEAT'
      }
      this.ensureSeatDefaults()
    },
    handleBillingModeChange () {
      if (!this.isOrgSeat && this.form.dailyPointGrantMode === 'PER_SEAT') {
        this.form.dailyPointGrantMode = 'SPACE_POOL'
      }
      this.ensureSeatDefaults()
    },
    ensureSeatDefaults () {
      if (this.isOrgSeat && (!this.form.minSeatCount || this.form.minSeatCount < 1)) {
        this.form.minSeatCount = 1
      }
    },
    seatConfigText (row) {
      if (row.billingMode !== 'ORG_SEAT') return '-'
      const min = row.minSeatCount || 1
      const max = row.maxSeatCount ? row.maxSeatCount : '不限'
      return `${this.formatAmount(row.seatPrice)} / ${min} 至 ${max} 席`
    },
    quotaText (value) {
      if (value === null || value === undefined || value === '') return '不限额'
      if (Number(value) === 0) return '无免费额度'
      return this.formatAmount(value)
    },
    pointPackageText (row) {
      const grant = Number(row.grantPointAmount || 0)
      const daily = Number(row.dailyPointAmount || 0)
      if (grant <= 0 && daily <= 0) return '-'
      return `开通 ${this.formatAmount(row.grantPointAmount)} / 每日 ${this.formatAmount(row.dailyPointAmount)}`
    },
    formatAmount (value) {
      if (value === null || value === undefined || value === '') return '0'
      const number = Number(value)
      if (!Number.isFinite(number)) return String(value)
      return number.toLocaleString('zh-CN', { maximumFractionDigits: 4 })
    },
    toNullableNumber (value) {
      if (value === null || value === undefined || value === '') return null
      const number = Number(value)
      return Number.isFinite(number) ? number : NaN
    },
    save () {
      const payload = Object.assign({}, this.form)
      const quotaAmount = this.toNullableNumber(payload.llmQuotaAmount)
      if (Number.isNaN(quotaAmount) || (quotaAmount !== null && quotaAmount < 0)) {
        this.$message.error('LLM套餐额度必须是非负数字，或留空表示不限额')
        return
      }
      payload.llmQuotaAmount = payload.agentPlusEnabled ? quotaAmount : null
      if (!payload.agentPlusEnabled) {
        payload.llmQuotaExhaustedPolicy = 'PAY_AS_YOU_GO'
      }

      if (payload.billingMode === 'ORG_SEAT') {
        const maxSeatCount = this.toNullableNumber(payload.maxSeatCount)
        if (Number.isNaN(maxSeatCount) || (maxSeatCount !== null && maxSeatCount < 1)) {
          this.$message.error('最大席位必须大于 0，或留空表示不限制')
          return
        }
        payload.minSeatCount = payload.minSeatCount || 1
        payload.maxSeatCount = maxSeatCount
      } else {
        payload.seatPrice = 0
        payload.minSeatCount = 0
        payload.maxSeatCount = null
        payload.dailyPointGrantMode = 'SPACE_POOL'
      }

      const request = payload.id ? updateSubscriptionPlan(payload) : saveSubscriptionPlan(payload)
      request.then(() => {
        this.$message.success('保存成功')
        this.dialog = false
        this.load()
      })
    }
  }
}
</script>

<style scoped>
.dialog-alert {
  margin-bottom: 12px;
}

.plan-form {
  padding-right: 8px;
}

.form-section-title {
  margin: 16px 0 12px;
  padding-left: 8px;
  border-left: 3px solid #409EFF;
  color: #303133;
  font-weight: 600;
  line-height: 16px;
}

.section-tip {
  margin: -4px 0 12px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.field-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
